import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class OmsValidationTableController implements IController {

  orders: any;
  selectedIds: [];
  isEditable: boolean;
  queryString: string;
  onSelectedIdsChanged: Function;
  onRemove: Function;
  onEdit: Function;

  private selectedKeys: any;

  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  }

  onToggleDelivery(orderId) {
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) {
        return key;
      }
    });
    this.onSelectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onToggleAllDeliveries() {
    const selectedIds = !_.isEqual(this.selectedIds.length, this.orders.length) ?
      _.map(this.orders, (order) => {
        return order.orderId;
      }):[];

    this.onSelectedIdsChanged({selectedIds: selectedIds});
  }

  onRemoveDelivery(id) {
    this.onRemove({ids: [id]});
  }

  onEditDelivery(order) {
    this.onEdit({order: order})
  }

}

angular
.module('bringoz.admin.oms')
.component('omsValidationTable', {
  bindings: {
    orders: '<',
    selectedIds: '<',
    isEditable: '<',
    queryString: '<',
    onSelectedIdsChanged: '&',
    onRemove: '&',
    onEdit: '&'
  },
  template: require('./oms-validation-table.html').default,
  controller: OmsValidationTableController
});
